import { CommonModule } from '@angular/common';
import { Component, inject} from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PageTemplateComponent } from '../../core/components/page-template/page-template.component';

@Component({
	selector: 'adf-error-page',
	standalone: true,
	imports: [CommonModule, RouterLink, PageTemplateComponent],
	templateUrl: './error-page.component.html',
	styleUrl: './error-page.component.scss',
})
export class ErrorPageComponent {
	readonly _activatedRoute = inject(ActivatedRoute);
	data$ = this._activatedRoute.data;
}
